import {HIT_ORIGINS, TRACKING_EVENT_NAMES} from './tracking.js'

export const CATEGORIES = {
  VEHICLE_CONFIGURATOR: {
    imageSrc: 'https://s.ccdn.es/images/coches/home-categories-vehicle-configurator.png',
    name: 'HOME_CATEGORIES_COCHES_VEHICLE_CONFIGURATOR',
    url: '/configurador/'
  },
  RENTING: {
    imageSrc: 'https://s.ccdn.es/images/coches/home-categories-renting.png',
    name: 'HOME_CATEGORIES_COCHES_RENTING',
    url: '/renting'
  },
  CERTIFIED_VEHICLES: {
    imageSrc: 'https://s.ccdn.es/images/coches/home-categories-certified.png',
    name: 'HOME_CATEGORIES_COCHES_CERTIFIED',
    url: '/segunda-mano-garantia?certification=true'
  },
  AUTOCARAVANS_AND_TRAILERS: {
    imageSrc: 'https://s.ccdn.es/images/coches/home-categories-caravans.png',
    name: 'HOME_CATEGORIES_COCHES_AUTOCARAVANS_AND_TRAILERS',
    url: '/autocaravanas-y-remolques/'
  },
  VANS_AND_COMMERCIAL: {
    imageSrc: 'https://s.ccdn.es/images/coches/home-categories-vans-and-commercial.png',
    name: 'HOME_CATEGORIES_COCHES_VANS_AND_COMMERCIAL',
    url: '/vehiculos-industriales/'
  },
  MOTORCYCLE: {
    imageSrc: 'https://s.ccdn.es/images/coches/home-categories-motos.png',
    name: 'HOME_CATEGORIES_COCHES_MOTORCYCLE',
    isExternal: true,
    url: 'https://motos.coches.net/ocasion/'
  },
  RENTING_BUSINESS: {
    imageSrc: 'https://s.ccdn.es/images/coches/home-categories-renting-business.png',
    name: 'HOME_CATEGORIES_COCHES_RENTING_BUSINESS',
    url: '/renting/empresas/'
  },
  RENTING_PRIVATES: {
    imageSrc: 'https://s.ccdn.es/images/coches/home-categories-renting.png',
    name: 'HOME_CATEGORIES_COCHES_RENTING_PRIVATES',
    url: '/renting/'
  }
}

export const HOME_CATEGORIES = [
  CATEGORIES.VEHICLE_CONFIGURATOR,
  CATEGORIES.RENTING_PRIVATES,
  CATEGORIES.RENTING_BUSINESS,
  CATEGORIES.CERTIFIED_VEHICLES,
  CATEGORIES.AUTOCARAVANS_AND_TRAILERS,
  CATEGORIES.VANS_AND_COMMERCIAL,
  CATEGORIES.MOTORCYCLE
]

export const BACKGROUND_IMAGE_URL_DESKTOP = 'coches/home-header-background-coches-desktop.jpg'
export const BACKGROUND_IMAGE_URL_MOBILE = 'coches/home-header-background-coches-mobile.jpg'

export const HOME_SELL_ACTIONS = [
  {
    imageUrl: 'https://s.ccdn.es/images/coches/pta/price-tag.svg',
    text: 'SELLER_SELECTOR.HERO_SELECTOR.PUBLISH_AD.TITLE.COCHES',
    trackingInfo: {
      hitOrigin: HIT_ORIGINS.HOME_PAGE,
      eventName: TRACKING_EVENT_NAMES.ACCESS_TO_AD_INSERTION_CLICKED
    },
    url: '/publicar-mi-anuncio/categoria'
  },
  {
    imageUrl: 'https://s.ccdn.es/images/coches/pta/lightning-fast.svg',
    text: 'SELLER_SELECTOR.HERO_SELECTOR.INSTANT_OFFER.TITLE.COCHES',
    trackingInfo: {
      hitOrigin: HIT_ORIGINS.HOME_PAGE,
      eventName: TRACKING_EVENT_NAMES.ACCESS_TO_INSTANT_OFFER_CLICKED
    },
    url: '/vender-mi-coche-a-un-concesionario'
  }
]

export const PROMOTIONAL_BANNER_ID_C2B = 'c2b-promo-banner'
export const PROMOTIONAL_BANNER_ID_DEFAULT = 'default-promo-banner'

export const PROMOTIONAL_BANNERS = [
  {
    ctaText: 'PROMOTIONAL_BANNER.C2B.CTA',
    description: 'PROMOTIONAL_BANNER.C2B.DESCRIPTION',
    imageUrl: 'coches/instant-offer/instant-offer-promo-banner-image.png',
    tagText: 'PROMOTIONAL_BANNER.C2B.TAG',
    title: 'PROMOTIONAL_BANNER.C2B.TITLE',
    type: PROMOTIONAL_BANNER_ID_C2B,
    url: '/vender-mi-coche-a-un-concesionario?origin=bannerHomeToStandalone'
  }
]

export const PROMOTIONAL_BANNERS_SECTION_TITLE = 'HOME_PROMOTIONAL_BANNERS_TITLE_COCHES'

export const ENABLE_GREEN_MOBILITY_SECTION = true
export const ENABLE_LIFESTYLE_CATEGORIES = true
export const ENABLE_PROMOTIONAL_BANNERS = true
export const ENABLE_MARKET_PLAYERS_SERVICES = true
